'use strict';
var $ = require('js/sw-jquery/sw-jquery');

$(document).ready( function () {
  $('body').on('submit', '[data-sw-reprint-form]', function(e) {
    var $el = $(this);
    var $checkBoxes = $el.find('[data-sw-reprint-checkbox]');
    $.each($checkBoxes, function () {
      if (this.checked) {
        var $row = $('[data-sw-reprint-row-' + this.dataset.swReprintCheckbox + ']');
        $row.fadeOut( 800, function () {
            $row.remove();
        });
      }
    });
  });
});
